"use strict";

exports.__esModule = true;

var toolbox_1 = require("../api/toolbox");

var shared_1 = require("../shared");

var Errors_1 = require("../../common/Errors");

var utils_1 = require("../../common/utils");

var Certificate_1 = require("./Certificate");

var _uniqBy = require("lodash/uniqBy");

var shared_2 = require("../api/shared");

exports.ErrorCodes = {
  ToolboxDecrypt: 'ToolboxDecrypt',
  ToolboxCertSearch: 'ToolboxCertSearch',
  ToolboxSearchCryptoProviders: 'ToolboxSearchCryptoProviders',
  ToolboxGetCryptoProLicense: 'ToolboxGetCryptoProLicense',
  ToolboxGetCryptoProviderContainers: 'ToolboxGetCryptoProviderContainers',
  ToolboxInstallCert: 'ToolboxInstallCert',
  NotImplemented: 'NotImplemented'
};

var Toolbox =
/** @class */
function () {
  function Toolbox() {}

  Toolbox.prototype.getInfo = function () {
    var result = {
      isInstalled: false,
      isBlocked: true,
      version: '',
      clientId: '' // not supported by Toolbox

    };
    var info = toolbox_1.Toolbox.getPluginInfo();

    if (info) {
      result.isBlocked = !!(info.denied || info.disabled);
      result.version = info.version;
      result.isInstalled = true;
    }

    return Promise.resolve(result);
  };

  Toolbox.prototype.searchCertificate = function (searchQuery, sink) {
    var store = searchQuery.store,
        hash = searchQuery.hash,
        serialNumber = searchQuery.serialNumber,
        hasPrivateKey = searchQuery.hasPrivateKey,
        qualified = searchQuery.qualified;

    if (store && store.type === shared_2.StoreType.Pkcs11) {
      return Promise.resolve([]);
    }

    var filter = {
      hasPrivateKeyOnly: hasPrivateKey,
      storeName: store ? store.name : undefined,
      storeLocation: store ? store.location : undefined,
      hash: hash,
      serialNumber: serialNumber
    };
    return new Promise(function (resolve, reject) {
      toolbox_1.Toolbox.Crypto.getCertificatesAsync(filter, function (error, arCertInfo) {
        if (error) {
          var message = "Toolbox certificate search error: " + error.message;
          return reject(new Errors_1.CommonError(message, null, exports.ErrorCodes.ToolboxCertSearch));
        }

        var certificates = arCertInfo.map(function (c) {
          try {
            return new Certificate_1["default"](c);
          } catch (error) {
            return null;
          }
        }).filter(utils_1.notEmpty);

        if (qualified) {
          certificates = certificates.filter(function (c) {
            return c.isQualified();
          });
        }

        certificates = _uniqBy(certificates, function (c) {
          return c.thumbprint();
        });
        resolve(certificates);
      });
    });
  };

  Toolbox.prototype.decrypt = function (source, sink) {
    return new Promise(function (resolve, reject) {
      var sourceBinary = source.type === 'base64' ? toolbox_1.Toolbox.Binary.fromBase64(source.data) : toolbox_1.Toolbox.Binary.fromHex(source.data);
      toolbox_1.Toolbox.Crypto.decryptAsync(sourceBinary, function (error, result) {
        try {
          if (error) {
            var message = "Toolbox decrypt error: " + error.message;
            return reject(new Errors_1.CommonError(message, null, shared_1.DecryptErrors.NoSecretKeyContainer));
          }

          var pluginContent = void 0;

          if (sink.type === 'base64') {
            pluginContent = {
              data: result.toBase64(),
              type: 'base64'
            };
          } else {
            pluginContent = {
              data: result.toHexString(),
              type: 'hex'
            };
          }

          if (!pluginContent.data) {
            throw new Error('Convert binary to string error');
          }

          resolve(pluginContent);
        } catch (error) {
          var message = "Toolbox decrypt error: " + error.message;
          return reject(new Errors_1.CommonError(message, null, exports.ErrorCodes.ToolboxDecrypt));
        }
      });
    });
  };

  Toolbox.prototype.encrypt = function () {
    throw new Errors_1.CommonError('Not implemented', null, exports.ErrorCodes.NotImplemented);
  };

  Toolbox.prototype.sign = function () {
    throw new Errors_1.CommonError('Not implemented', null, exports.ErrorCodes.NotImplemented);
  };

  Toolbox.prototype.batchSign = function () {
    throw new Errors_1.CommonError('Not implemented', null, exports.ErrorCodes.NotImplemented);
  };

  Toolbox.prototype.displayCertificate = function (certificate) {
    certificate.raw().display();
    return Promise.resolve();
  };

  Toolbox.prototype.searchCryptoProviders = function (cryptoProviderType) {
    if (cryptoProviderType === shared_2.CryptoProviderType.Pkcs11) {
      return Promise.resolve([]);
    }

    try {
      var cryptoProviders = toolbox_1.Toolbox.Crypto.getProvidersInfos().map(function (_a) {
        var name = _a.name,
            type = _a.type,
            version = _a.version,
            pkzi = _a.pkzi,
            skzi = _a.skzi;
        return {
          type: shared_2.CryptoProviderType.CryptoApi,
          id: type,
          version: version,
          name: name,
          algorithms: [],
          pkzi: pkzi,
          skzi: skzi
        };
      });
      return Promise.resolve(cryptoProviders);
    } catch (error) {
      var message = "Toolbox getProvidersInfos error: " + error.message;
      return Promise.reject(new Errors_1.CommonError(message, null, exports.ErrorCodes.ToolboxSearchCryptoProviders));
    }
  };

  Toolbox.prototype.getCryptoProLicense = function (guid) {
    try {
      return Promise.resolve(toolbox_1.Toolbox.Crypto.getCryptoProLicense(guid));
    } catch (error) {
      var message = "Toolbox getCryptoProLicense error: " + error.message;
      return Promise.reject(new Errors_1.CommonError(message, null, exports.ErrorCodes.ToolboxGetCryptoProLicense));
    }
  };

  Toolbox.prototype.getCryptoProviderContainers = function () {
    return Promise.reject(new Errors_1.CommonError('Toolbox does not support this method', null, exports.ErrorCodes.ToolboxGetCryptoProviderContainers));
  };

  Toolbox.prototype.installCertificate = function () {
    return Promise.reject(new Errors_1.CommonError('Toolbox does not support this method', null, exports.ErrorCodes.ToolboxInstallCert));
  };

  Toolbox.prototype.close = function () {// Not supported by Toolbox;
  };

  return Toolbox;
}();

exports.Toolbox = Toolbox;